import {useEffect, useState, useRef} from 'react'

export default function useDynamicBackground({initialState = false}: {initialState?: boolean}) {
  const [isBackgroundDark, setIsBackgroundDark] = useState(initialState)
  const lastScrollY = useRef(0)

  // Obersection to detect when sections are in view
  useEffect(() => {
    const sections = document.querySelectorAll('section[data-nav-dark="true"], footer[data-nav-dark="true"]')

    const handleScroll = () => {
      const scrollY = window?.scrollY || 0
      const direction = scrollY > lastScrollY.current ? 'down' : 'up'
      lastScrollY.current = scrollY

      let shouldInvert = false

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect()

        if (
          (direction === 'down' && rect.top <= 50 && rect.bottom > 50) ||
          (direction === 'up' && rect.top <= 5 && rect.bottom > 0)
        ) {
          shouldInvert = true
        }
      })

      setIsBackgroundDark(shouldInvert)
    }

    window.addEventListener('scroll', handleScroll, {passive: true})
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return {isBackgroundDark}
}
